// App.js
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppRouter from './router';
import "./App.css"
import Header from './components/Header';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <section className='app-layout-wrapper'>
        <div className='app-header-wrapper'>
          <Header />
        </div>
        <div className='app-body-wrapper'>
          <AppRouter />
        </div>
        <div className='app-footer-wrapper'>
          <Footer />
        </div>
      </section>
    </Router>
  );
}

export default App;
